import { render, staticRenderFns } from "./document-extraction-modal.vue?vue&type=template&id=4bbac542"
import script from "./document-extraction-modal.vue?vue&type=script&lang=ts"
export * from "./document-extraction-modal.vue?vue&type=script&lang=ts"
import style0 from "./document-extraction-modal.vue?vue&type=style&index=0&id=4bbac542&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports